import { render, staticRenderFns } from "./HistorySingoHolter.vue?vue&type=template&id=ac5a83ac&scoped=true&"
import script from "./HistorySingoHolter.vue?vue&type=script&lang=js&"
export * from "./HistorySingoHolter.vue?vue&type=script&lang=js&"
import style0 from "./HistorySingoHolter.vue?vue&type=style&index=0&id=ac5a83ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5a83ac",
  null
  
)

export default component.exports